import React from 'react';

import styles from './Label.css';

export default function Label(props) {
  return (
    <label className={styles.labelContainer}>
      <div className={styles.label}>
        {props.label}
      </div>
      {props.children}
    </label>
  );
}



/** WEBPACK FOOTER **
 ** ./client/form/Label.js
 **/